import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../img/logo-nikted.png'
import _imports_1 from '../img/icon-profile.png'
import _imports_2 from '../img/icon-record.png'
import _imports_3 from '../img/icon-phone.png'
import _imports_4 from '../img/icon-exit-acount.png'


const _withScopeId = n => (_pushScopeId("data-v-012eeaeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smartphone-menu-trigger" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "c"
  })
], -1))
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  class: "col-12",
  style: {"font-size":"14px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr" }, null, -1))
const _hoisted_10 = { tabindex: "0" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "profile"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " مشخصات", -1))
const _hoisted_14 = { tabindex: "0" }
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "record"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " بیماران ", -1))
const _hoisted_18 = { tabindex: "0" }
const _hoisted_19 = { class: "icon" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "contactus"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "پشتیبانی", -1))
const _hoisted_22 = {
  tabindex: "0",
  class: "exit"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "contactus"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "خروج", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "hamburger-menu",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
    }, _hoisted_4),
    _createElementVNode("nav", {
      class: _normalizeClass(["menu", { 'menu-open': _ctx.isMenuOpen }])
    }, [
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, " دکتر " + _toDisplayString(_ctx.first_name + _ctx.last_name), 1)
      ]),
      _hoisted_9,
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, {
              class: "link",
              to: "/doctor/profile",
              onClick: _ctx.toggleMenu
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("li", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_router_link, {
              class: "link",
              to: "/doctor/patients",
              onClick: _ctx.toggleMenu
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                _hoisted_17
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("li", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_router_link, {
              class: "link",
              to: { name: 'contact-us' },
              onClick: _ctx.toggleMenu
            }, {
              default: _withCtx(() => [
                _hoisted_20,
                _hoisted_21
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("li", _hoisted_22, [
          _createElementVNode("div", {
            class: "icon",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
          }, [
            _createVNode(_component_router_link, {
              class: "link",
              to: ""
            }, {
              default: _withCtx(() => [
                _hoisted_23,
                _hoisted_24
              ]),
              _: 1
            })
          ])
        ])
      ])
    ], 2)
  ], 64))
}